import { MobileFieldsOfLane, MobileFieldTypes, MobileField } from '@components/MobileCardList';
import { translate } from '@chaika/i18n/helper';

import { OrganizationRow } from './useColumns';

interface Data {
    mobileFields: MobileField<OrganizationRow>[];
}

export function useMobileFields(): Data {
    const mobileFields: MobileField<OrganizationRow>[] = [
        {
            title: translate('nameSecond'),
            accessor: 'name',
            isPrimary: true,
            withoutTitle: true,
            fieldType: MobileFieldTypes.Text,
        },
        {
            title: 'Store ID',
            accessor: 'storeId',
            fieldType: MobileFieldTypes.Text,
            fieldsOnLane: MobileFieldsOfLane.SingleField,
        },
    ];

    return { mobileFields };
}
